import * as React from 'react'

import Box from '@mui/material/Box'
import { Select } from '@workwave-tidal/core/components'
import FormHelperText from '@mui/material/FormHelperText'

import { useData, useHandlers } from './hooks'
import { ISource } from '@user/store/sources'
import { ScrollToErrorMarker } from '@user/components/Formik/ScrollToErrorMarker'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'

type Props = {
  required: boolean
  show: boolean
  name: string
  label: string
  density: DensityType
  disabled: boolean
}

export function LeadSourceSelect(props: Props) {
  const { required, show, name, disabled, ...rest } = props
  const { initialOption, isSubmitting, showError, helperText, ...restUseData } =
    useData({ required, name })
  const { handelChange, handelFocus, handelBlur } = useHandlers({ name })

  return show ? (
    <Box>
      <Select<ISource>
        {...restUseData}
        {...rest}
        disabled={isSubmitting || disabled}
        required={required}
        error={showError}
        onChange={handelChange}
        value={initialOption}
        optionMode={'normal'}
        onFocus={handelFocus}
        onBlur={handelBlur}
        testId="lead-source-select"
      />
      {showError && (
        <FormHelperText sx={{ ml: 1 }} error>
          {helperText}
        </FormHelperText>
      )}
      <ScrollToErrorMarker fieldName={name} />
    </Box>
  ) : null
}
